export default "__VITE_ASSET__DKoeG8Jm__ 288w, __VITE_ASSET__Bu1ZU0ya__ 432w, __VITE_ASSET__oMPWJWZB__ 576w";